import React from "react";
import { Container } from "react-bootstrap";

function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#343a40", // A more appealing background color
        color: "#fff",
        padding: "40px 0", // Increase padding for better spacing
        textAlign: "center", // Center the text
      }}
    >
       
        {/* Footer Bottom Section */}
        <div
          style={{
            fontSize: "14px",
            color: "#aaa", // A lighter gray color for bottom text
          }}
        >
          <p style={{ margin: "0" }}>
            &copy; {new Date().getFullYear()} FELIX OWUSU. All Rights Reserved.
          </p>
          <p style={{ margin: "5px 0" }}>
            Built with <span style={{ color: "#f8d210" }}>❤️</span> by You
          </p>
        </div>
       

      {/* Custom Styling for Links */}
      <style>
        {`
          footer a {
            text-decoration: none;
          }
          footer a:hover {
            color: #fff !important;
          }
        `}
      </style>
    </footer>
  );
}

export default Footer;
